export default __webpack_public_path__ + "static/media/xls-icon.5e92a060.svg";